import { awaitMemberstack } from '@urbanchallenger/sdk';

const PAGE_PROFILE = '/profile';
const PAGE_POST_SIGNUP = '/success';
const PAGE_SIGNUP = '/signup';

const DEFAULT_REDIRECT = PAGE_PROFILE;
const IGNORED_PATHS = ['/login', PAGE_SIGNUP];
// paths that are not protected by Memberstack, but should not be available to
// non-authenticated users
const SIGNUP_REQUIRED_PATHS = ['/start'];

const StoreKeys = {
    intendedTarget: 'uc:nav-target',
    retry: 'uc:nav-retry',
};

void (async function () {
    const url = new URL(window.location.href);
    const { tokenPromise } = awaitMemberstack();
    const token = await tokenPromise;

    if (url.pathname.startsWith(PAGE_POST_SIGNUP)) {
        // Reading logic and redirecting only on this page
        let redirectTarget: string;

        if (!token) {
            // The user is not authenticated. Whichever way they ended up here,
            // they need to authenticate first.
            // eslint-disable-next-line no-useless-assignment
            redirectTarget = PAGE_SIGNUP;
            // **But** we don't want to end up in a redirect loop, in case it
            // was indeed Memberstack that directed them here without proper
            // authentication.
            const hasRetried = window.sessionStorage.getItem(StoreKeys.retry);

            if (hasRetried) {
                window.alert(
                    'Something went wrong while logging you in. Please restart your browser and try again.'
                );
                throw new Error('Redirect loop avoided');
            }

            window.sessionStorage.setItem(StoreKeys.retry, 'true');
        }

        // Find out where the user wanted to go originally:
        const intendedTarget = window.sessionStorage.getItem(
            StoreKeys.intendedTarget
        );

        if (intendedTarget) {
            redirectTarget = intendedTarget;
        } else {
            // The user probably came directly onto a signup
            // page or from an IGNORED_PATH.
            redirectTarget = DEFAULT_REDIRECT;
        }

        // Clear the sessionStorage entry so it doesn't crossfire later:
        window.sessionStorage.removeItem(StoreKeys.intendedTarget);
        // We don't want POST_SIGNUP to show up in history, so we use replace()
        // to redirect the user.
        window.location.replace(redirectTarget);
    } else if (
        !token &&
        !IGNORED_PATHS.some((p) => url.pathname.startsWith(p))
    ) {
        // User is not authenticated, so they might need to save their last
        // known location.
        // We're also _not_ on an ignored path, so we can store the intended
        // target.
        // The POST_SIGNUP page is excluded implicitly through the first
        // branch of the conditional.
        window.sessionStorage.setItem(StoreKeys.intendedTarget, url.toString());

        // If this current page is not protected by Memberstack, but requires
        // a user to be signed in, we redirect them to the signin page.
        // Currently this is only the /start page used by QR codes & deeplinks.
        if (SIGNUP_REQUIRED_PATHS.some((p) => url.pathname.startsWith(p))) {
            window.location.replace(PAGE_SIGNUP);
        }
    }
})();
